var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteAccountWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72074 5.15337L3.21449 6.46854L2.14307 13.4328L9.10735 12.3614L10.4225 8.85515",
    stroke: "white",
    strokeWidth: 1.28571,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14307 13.4328L5.67128 9.90462",
    stroke: "white",
    strokeWidth: 1.28571,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50033 2.71834L5.89307 4.32561L11.2501 9.68265L12.8574 8.07538L7.50033 2.71834Z",
    stroke: "white",
    strokeWidth: 1.28571,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18591 9.90472C7.60432 9.4863 7.60432 8.80792 7.18591 8.3895C6.76749 7.97109 6.08911 7.97109 5.67069 8.3895C5.25228 8.80792 5.25228 9.4863 5.67069 9.90472C6.08911 10.3231 6.76749 10.3231 7.18591 9.90472Z",
    stroke: "white",
    strokeWidth: 1.28571,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAccountWhite);
export default __webpack_public_path__ + "static/media/deleteAccountWhite.27665fd3cb9ac4a3084fbbf3b0ed129e.svg";
export { ForwardRef as ReactComponent };